// extracted by mini-css-extract-plugin
export default {"terms":"styles_terms__e18Uu"};